import { Blog } from "@/types/blog";

const blogData: Blog[] = [
  {
    id: 1,
    title: "Best UI components for modern websites",
    paragraph: "Learn how to build sleek, scalable, and reusable UI libraries for your projects.",
    image: "/images/blog/blog-01.jpg",
    author: {
      name: "Samuyl Joshi",
      image: "/images/blog/author-01.png",
      designation: "UI Engineer",
    },
    tags: ["UI", "frontend"],
    publishDate: "2025",
  },
  {
    id: 2,
    title: "9 simple ways to improve your design skills",
    paragraph: "Practical tips and techniques for designers to sharpen their craft in 2025.",
    image: "/images/blog/blog-02.jpg",
    author: {
      name: "Musharof Chy",
      image: "/images/blog/author-02.png",
      designation: "Content Writer",
    },
    tags: ["design", "creativity"],
    publishDate: "2025",
  },
  {
    id: 3,
    title: "Tips to quickly improve your coding speed.",
    paragraph: "Boost your productivity with these proven techniques for faster, cleaner code.",
    image: "/images/blog/blog-03.jpg",
    author: {
      name: "Lethium Deo",
      image: "/images/blog/author-03.png",
      designation: "Full-Stack Developer",
    },
    tags: ["coding", "productivity"],
    publishDate: "2025",
  },
];

export default blogData;
